import { render, staticRenderFns } from "./CyberboardR6Navigation.vue?vue&type=template&id=2e4006a3&scoped=true&"
import script from "./CyberboardR6Navigation.vue?vue&type=script&lang=js&"
export * from "./CyberboardR6Navigation.vue?vue&type=script&lang=js&"
import style0 from "./CyberboardR6Navigation.vue?vue&type=style&index=0&id=2e4006a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4006a3",
  null
  
)

export default component.exports